<template lang="html">
  <chart :chartData="currentDataChart" :options="options" v-if="currentDataChart !== undefined"></chart>
  <spinner v-else></spinner>
</template>

<script>
import Chart from '@/pages/statistics/components/graphiques/BarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import * as R from 'ramda'
import {statusLabel} from '@/helpers/labels'

export default {
  props: ['showAmountNotNumber', 'chartData'],
  data () {
    return {
      options: undefined
    }
  },
  components: {
    'chart': Chart,
    'spinner': Spinner
  },
  created () {
    this.options = {
      responsive: true,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            stepSize: 200,
            beginAtZero: true
          }
        }]
      },
      legend: {
        display: false,
        fullWidth: false,
        align: 'start'
      }
    }
  },
  computed: {
    currentDataChart () {
      if (this.chartData !== undefined) {
        return this.makeChartDataTotal(this.chartData)
      }
    }
  },
  /* watch: {
    showAmountNotNumber: {
      handler () {
        if (this.$engine.monitoring.graphTransactions !== undefined) {
          this.chartData = this.makeChartData(this.$engine.monitoring.graphTransactions)
        }
      }
    }
  }, */
  methods: {
    makeChartDataTotal (rawData) {
      let data = {
        labels: ['total'],
        datasets: []
      }
      let backgroundColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)'
      ]
      let borderColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)'
      ]

      let transactionKeys = R.keys(rawData.total)
      for (let key in transactionKeys) {
        let keys = R.keys(rawData.total[key])
        for (let el in keys) {
          if (key === status) {
            data.datasets.push({data: [keys[el]], label: statusLabel(this.$i18n, el, '0'), backgroundColor: backgroundColor, borderColor: borderColor})
          } else {
              data.datasets.push({data: [keys[el]], label: el, backgroundColor: backgroundColor, borderColor: borderColor})
          }
        }
      }
      return data
    }
  }
    /* makeChartData (rawData) {
      let data = {
        labels: [],
        datasets: []
      }
      // labels -> month or days
      // datasets -> label -> label status or creditor_bic or debtor_bic
      //         |-> data -> number of times in history

      // role sender status labels
      let transactionKeys = R.keys(rawData.TransactionStatHistory)
      for (let key in transactionKeys) {
        if (transactionKeys === month) {
          data.labels.push(statusLabel(this.$i18n, transactionKeys[key], '0'))
        }
      }
      // prepare datasets
      let dataCred = {data: [], label: '', backgroundColor: [], borderColor: []}
      // add creditor dataset
      for (let credStatus in rawData.creditor) {
        if (credStatus) {
          dataCred.data = R.append(rawData.creditor[credStatus].amount, dataCred.data)
        }
      }

      // graph label and colors
      dataCred.label = this.$i18n.t('graph.rcvd')
      dataCred.backgroundColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(41, 120, 76, 0.8)'
      ]
      dataCred.borderColor = [
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)',
        'rgba(125, 207, 164, 0.8)',
        'rgba(106, 200, 151, 0.8)',
        'rgba(87, 193, 138, 0.8)',
        'rgba(69, 186, 126, 0.8)',
        'rgba(62, 168, 113, 0.8)',
        'rgba(55, 149, 100, 0.8)',
        'rgba(48, 130, 88, 0.8)'
      ]

      data.datasets = [dataCred]
      return data
    } */
  }
</script>
